import styled, { css } from 'styled-components';

export const Container = styled.section`
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 8px;
    border: 2px solid ${({ theme }) => theme.colors['Level 1']};
    cursor: pointer;
    padding: 9px;
    width: 56px;
    height: 56px;
    ${({ disabled }: { disabled: boolean }) =>
        disabled &&
        css`
            opacity: 0.6;
        `}
`;

export const Image = styled.img`
    max-width: 100%;
    max-height: 100%;
    width: auto;
    height: auto;
`;
